import * as React from 'react';
import * as styles from './NavItem.scss';
import { createImageUrl } from '@/services/image.service';

interface INavItem {
    isActive: boolean;
    title: string;
    iconPath: string;
    onClick: () => any;
}

export const NavItem: React.FC<INavItem> = ({ iconPath, title, isActive, onClick }) => {
    return (
        <div className={`${styles.navItem} ${isActive ? styles.navItemActive : ''}`} onClick={onClick}>
            <div className={styles.navItemInnerBox}>
                <div className={styles.navItemIcon}>
                    <img alt={title} className={styles.navItemIconSvg} src={createImageUrl(iconPath)} />
                </div>
                <p dangerouslySetInnerHTML={{ __html: title }} className={styles.navItemTitle} />
            </div>
        </div>
    );
};
